export const SupportResponseTimeNote = ({ created = false }) => (
  <p role={created ? "status" : undefined}
     className={`border-l-2 pl-3 py-1 text-sm leading-relaxed ${created ? "support-ux-response--sent" : "border-[#90A995] text-[#4D5F52]"}`}
     data-testid={created ? "support-created-response-time" : "support-new-response-time"}>
    {created && <strong className="font-semibold">Ticket inviato. </strong>}
    Il nostro team risponderà alla tua richiesta entro un massimo di 24 ore.
  </p>
);